import { useMemo } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { albums as localAlbums } from "../albums.js";
import { normalizeLang, translations } from "../../../i18n"; 
import "./Albums.css";

const Albums = () => {
  const { albums: storeAlbums } = useSelector((s) => s.home);

  const user = useSelector((state) => state.user.data);

  const lang = normalizeLang(user?.languageCode);
  const t = translations[lang];

  const combinedAlbums = useMemo(() => {
    const mappedLocal = (localAlbums || []).map((alb, idx) => ({
      ...alb,
      id: `local-${idx}`,
      photo: alb.photos && alb.photos[0] ? alb.photos[0] : "",
    }));
    return [...(storeAlbums || []), ...mappedLocal];
  }, [storeAlbums]);

  return (
    <div>
      <div className="contentLabel" style={{ marginBottom: 10 }}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <svg
            style={{ marginRight: "5px" }}
            width="15"
            height="15"
            viewBox="0 0 15 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3.33333 0C1.4925 0 0 1.4925 0 3.33333V10.8333V11.6667C0 13.5075 1.4925 15 3.33333 15H11.6667C13.5075 15 15 13.5075 15 11.6667V10.8333V3.33333C15 1.4925 13.5075 0 11.6667 0H3.33333ZM3.33333 1.66667H11.6667C12.5875 1.66667 13.3333 2.4125 13.3333 3.33333L13.3367 8.49665C12.6883 7.89499 12.0275 7.51833 11.3017 7.5C11.2758 7.49917 11.2767 7.5 11.25 7.5C10.3025 7.5 9.24917 8.22833 8.54167 9.14083C8.36083 8.73249 8.17834 8.32917 7.96834 7.9425C6.98501 6.12667 5.91083 5.0025 4.58333 5C3.455 4.9975 2.48667 5.92 1.66 7.18333L1.66667 3.33333C1.66667 2.4125 2.4125 1.66667 3.33333 1.66667ZM10.8333 3.33333C10.3733 3.33333 10 3.70667 10 4.16667C10 4.62667 10.3733 5 10.8333 5C11.2933 5 11.6667 4.62667 11.6667 4.16667C11.6667 3.70667 11.2933 3.33333 10.8333 3.33333ZM4.58333 6.66667C5.06833 6.6675 5.80501 7.42249 6.51001 8.72416C6.79001 9.23916 7.04083 9.80666 7.26583 10.365C7.40083 10.6983 7.50501 10.9533 7.55168 11.0933C7.77918 11.7742 8.7025 11.8708 9.0625 11.25C9.09833 11.1883 9.16333 11.07 9.27083 10.9117C9.45083 10.645 9.65583 10.375 9.86999 10.13C10.405 9.51667 10.9208 9.16667 11.25 9.16667C11.5825 9.175 12.0958 9.52417 12.63 10.13C12.8467 10.3758 13.0467 10.645 13.2292 10.9117C13.2867 10.995 13.295 11.0342 13.3333 11.0933V11.6667C13.3333 12.5875 12.5875 13.3333 11.6667 13.3333H3.33333C2.4125 13.3333 1.66667 12.5875 1.66667 11.6667V10.9633C1.71917 10.815 1.78917 10.6392 1.90084 10.365C2.12834 9.80666 2.37499 9.23999 2.65666 8.72416C3.36749 7.41999 4.09917 6.66583 4.58333 6.66667Z"
              fill="black"
            />
          </svg>
          <p>{t.titleAlbums}</p>
        </div>
      </div>

      <div className="shop__grid" style={{ margin: "0px 15px 84px" }}>
        {combinedAlbums.map((a) => (
          <Link
            key={a.id || a.title}
            to={`/album/${encodeURIComponent(a.id || a.title)}`}
            state={{ album: a }}
            style={{ margin: 0 }}
          >
            <div className="shop__card">
              <div className="shop__img-wrapper">
                <img className="shop__img" src={a.photo} alt={a.title} />
                <svg
                  className="shop__svg"
                  width="25"
                  height="25"
                  viewBox="0 0 25 25"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="12.5"
                    width="17.6777"
                    height="17.6777"
                    rx="8.83883"
                    transform="rotate(45 12.5 0)"
                    fill="black"
                    fillOpacity="0.4"
                  />
                  <path
                    d="M11.5423 9.62565L15.3757 9.62565M15.3757 9.62565L15.3757 13.459M15.3757 9.62565L9.62565 15.3757"
                    stroke="white"
                    strokeWidth="0.9"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <div className="shop__img-overlay" />
              </div>
              <p className="shop__name" style={{ fontWeight: "400" }}>
                {a?.[`title_${lang}`]}
              </p>
              <p className="shop__short">{a.shortDesc}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Albums;
